import { fetchUtils } from 'react-admin';
import { createIdsArray, getQueryParams } from '../helpers/api';

// NOTE: Production REACT_APP_BASE_PATH must include the backend /api prefix (e.g. https://api.bcharg.com/api)
export const apiUrl = process.env.REACT_APP_BASE_PATH;

const httpClient = async (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' });
  }
  options.headers.set('Authorization', `Bearer ${localStorage.getItem('auth')}`);
  return fetchUtils.fetchJson(url, options);
};

export default {
  getList: (resource, params) => {
    const query = {
      pagination: params.pagination,
      sort: params.sort,
      filter: params.filter
    };
    const queryParams = getQueryParams(query);
    let url = null;

    if (resource == 'transactions') {
      const branchStorage = localStorage.getItem('RaStore.branch');
      const jsonBranch = branchStorage ? JSON.parse(branchStorage) : { id: 'noid' };
      url = `${apiUrl}/branches/${jsonBranch.id}/transactions/${queryParams}`;
    } else {
      url = `${apiUrl}/${resource}/${queryParams}`;
    }
    return httpClient(url).then(({ headers, json }) => {
      let data = json?.results;
      if (resource.includes('/')) { //esto es porque las rutas que tienen / no devuelven bien formateado
        data = createIdsArray(data);
      }
      return ({
        data: resource == 'dashboard' ? [{ id: 1, data }] : data,
        total: json?.paging?.total
      });
    });
  },

  getOne: (resource, params) =>
    httpClient(`${apiUrl}/${resource}/${params.id}`).then(({ json }) => ({
      data: json,
    })),

  getMany: (resource, params) => {
    const query = {
      filter: JSON.stringify({ ids: params.ids }),
    };
    const url = `${apiUrl}/${resource}?${JSON.stringify(query)}`;
    return httpClient(url).then(({ json }) => {
      let data = json.results;
      if (resource.includes('/')) { //esto es porque las rutas que tienen / no devuelven bien formateado
        data = createIdsArray(data);
      }
      return ({
        data: data
      });
    });
  },

  getManyReference: (resource, params) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const query = {
      sort: JSON.stringify([field, order]),
      range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
      filter: JSON.stringify({
        ...params.filter,
        [params.target]: params.id,
      }),
    };
    const url = `${apiUrl}/${resource}?${JSON.stringify(query)}`;

    return httpClient(url).then(({ headers, json }) => ({
      data: json.results,
      total: json.paging.total
    }));
  },

  getCustom: (resource) => {
    const url = `${apiUrl}/${resource}`;
    return httpClient(url).then(({ json }) => json);
  },

  create: (resource, params) => {
    return httpClient(`${apiUrl}/${resource}/`, {
      method: 'POST',
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({
      data: { ...params.data, id: json.id },
    }));
  },

  update: (resource, params) =>
    httpClient(`${apiUrl}/${resource}/${params.id}`, {
      method: 'PUT',
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({ data: json })),

  updateMany: (resource, params) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    return httpClient(`${apiUrl}/${resource}?${JSON.stringify(query)}`, {
      method: 'PUT',
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({ data: json }));
  },

  delete: (resource, params) =>
    httpClient(`${apiUrl}/${resource}/${params.id}`, {
      method: 'DELETE',
    }).then(({ json }) => ({ data: json })),

  deleteMany: (resource, params) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    return httpClient(`${apiUrl}/${resource}?${JSON.stringify(query)}`, {
      method: 'DELETE',
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({ data: json }));
  },
};